import { clearNavbarTheme, setNavbarTheme } from '../shared/navbar-theme.js';

let themedSectionSequence = 0;

const getNavbarHeight = () => {
  if (typeof document === 'undefined') {
    return 0;
  }

  return document.querySelector('.nav')?.offsetHeight || 0;
};

const getSectionTheme = (section) => section.dataset.navTheme || section.dataset.theme;

const getThemedSections = () =>
  Array.from(
    new Set(
      Array.from(
        document.querySelectorAll(
          'section[data-nav-theme], section[data-theme], .section[data-nav-theme], .section[data-theme]'
        )
      )
    )
  ).filter((section) => !section.closest('.section__intro-track'));

const initNavbarThemeSection = (section, ScrollTrigger) => {
  if (section.dataset.navThemeReady === 'true') {
    return;
  }

  const theme = getSectionTheme(section);

  if (!theme) {
    return;
  }

  const themeSource = `navbar-theme-section-${themedSectionSequence += 1}`;

  section.dataset.navThemeReady = 'true';

  ScrollTrigger.create({
    trigger: section,
    start: () => `top top+=${getNavbarHeight()}`,
    end: () => `bottom top+=${getNavbarHeight()}`,
    invalidateOnRefresh: true,
    onRefresh: (self) => {
      if (self.isActive) {
        setNavbarTheme(themeSource, theme);
        return;
      }

      clearNavbarTheme(themeSource);
    },
    onEnter: () => {
      setNavbarTheme(themeSource, theme);
    },
    onEnterBack: () => {
      setNavbarTheme(themeSource, theme);
    },
    onLeave: () => {
      clearNavbarTheme(themeSource);
    },
    onLeaveBack: () => {
      clearNavbarTheme(themeSource);
    },
  });
};

export const initNavbarThemeSections = (ScrollTrigger) => {
  if (!ScrollTrigger) {
    return;
  }

  getThemedSections().forEach((section) => {
    initNavbarThemeSection(section, ScrollTrigger);
  });
};

if (typeof window !== 'undefined') {
  window.initNavbarThemeSections = (ScrollTrigger = window.ScrollTrigger) => {
    initNavbarThemeSections(ScrollTrigger);
  };
}
